export default function firstDayOnWeek(date) {
    return date.getDate() - date.getDay();
}
